import PropTypes from 'prop-types'
import { NavLink } from 'react-router'

function NavButton({ children, to }) {
  // NavLink appends the `active` class itself when the route matches
  return (
    <NavLink end to={to} className="navButton">
      {children}
    </NavLink>
  )
}

NavButton.propTypes = {
  to: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
  ]),
}

export default NavButton
